import CollapsibleContainer, {
  CollapsibleContainerProps,
  CollapsibleContainerRef,
  OnToggleCollapsibleContainerArgs,
} from "mt-components/CollapsibleContainer/CollapsibleContainer";
import {
  ForwardedRef,
  ReactNode,
  forwardRef,
  useCallback,
  useState,
} from "react";
import { tracker } from "../../../../../utils/analytics2";
import { Text } from "../../../../Atoms/Typography";
import { CollapsibleContainerName } from "../../collapsibleContainerAbTest";

export type CollapsibleProductContainerProps = Omit<
  CollapsibleContainerProps,
  "collapsibleProps"
> & {
  abValue?: string; // tmp var for a/b testing
  fallbackRenderer?: (content: ReactNode) => ReactNode; // tmp var for a/b testing
  ga4Label?: CollapsibleContainerName; // tmp var for a/b testing
  isCollapsible?: boolean; // tmp var for a/b testing
};
const CollapsibleProductContainer = forwardRef<
  CollapsibleContainerRef | HTMLDivElement,
  React.PropsWithChildren<CollapsibleProductContainerProps>
>(
  (
    { children, abValue, ga4Label, fallbackRenderer, isCollapsible, ...props },
    ref
  ) => {
    const [lastEventTime, setLastEventTime] = useState<number | null>(null);

    const onToggle = useCallback(
      ({ isOpen }: OnToggleCollapsibleContainerArgs) => {
        const now = Date.now();

        if (
          abValue &&
          ga4Label &&
          isOpen &&
          (!lastEventTime || now - lastEventTime > 2000)
        ) {
          // if we are opening the container and the button is not being spammed
          // track the event
          tracker.trackEvent({
            category: "collapsible-container",
            action: "open",
            label: ga4Label,
            value: abValue,
          });
          setLastEventTime(now);
        }
      },
      [abValue, ga4Label, setLastEventTime, lastEventTime]
    );

    return isCollapsible ? (
      <CollapsibleContainer
        ref={ref as ForwardedRef<CollapsibleContainerRef>}
        {...props}
        collapsibleProps={{
          style: {
            marginBottom: "50px",
          },
        }}
        onToggle={onToggle}
        labelRenderer={(label) => (
          <Text
            size="large"
            style={{
              flexGrow: 1,
            }}
          >
            {label}
          </Text>
        )}
      >
        {children}
      </CollapsibleContainer>
    ) : (
      <div ref={ref as ForwardedRef<HTMLDivElement>}>
        {fallbackRenderer ? fallbackRenderer(children) : children}
      </div>
    );
  }
);

CollapsibleProductContainer.displayName = "CollapsibleProductContainer";
export default CollapsibleProductContainer;
